export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["Pending"] = "Pending";
    RequestStatus["RemoteError"] = "RemoteError";
    RequestStatus["RemoteResult"] = "RemoteResult";
    RequestStatus["ForcedError"] = "ForcedError";
    RequestStatus["ForcedResult"] = "ForcedResult";
    RequestStatus["TimeoutError"] = "TimeoutError";
    RequestStatus["RequestAborted"] = "RequestAborted";
    RequestStatus["SkipRsvp"] = "SkipRsvp";
})(RequestStatus || (RequestStatus = {}));
export var LogActivity;
(function (LogActivity) {
    LogActivity["TransportSendingPayload"] = "TransportSendingPayload";
    LogActivity["TransportReceivingMessage"] = "TransportReceivingMessage";
    LogActivity["TransportStopping"] = "TransportStopping";
    LogActivity["TransportIgnoringMessage"] = "TransportIgnoringMessage";
    LogActivity["RelaySendingPayload"] = "RelaySendingPayload";
    LogActivity["RelayIgnoringMessage"] = "RelayIgnoringMessage ";
    LogActivity["ReceivedInvalidPayload"] = "ReceivedInvalidPayload";
    LogActivity["IgnoringPayload"] = "IgnoringPayload";
    LogActivity["Misc"] = "MiscActivity";
    LogActivity["ReportWarning"] = "Warning";
    LogActivity["ReportError"] = "Error";
})(LogActivity || (LogActivity = {}));
//# sourceMappingURL=interfaces.js.map